import React from 'react';
import { object, func, array } from 'prop-types';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Directions from '@alltrails/shared/icons/Directions';
import Share from '@alltrails/shared/icons/Share';
import { COLOR_INTERACTIVE_PRIMARY } from '@alltrails/shared/denali/tokens';

import UserImageLink from '../UserImageLink';
import MenuPop from '../MenuPop';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const HeaderButtons = ({ context, user, handleDirectionsClick, handleShareClick, menuItems }) => {
  return (
    <div className={styles.buttonPanel}>
      <div className={styles.userImage}>
        <UserImageLink context={context} user={user} />
      </div>
      <div className={styles.circleIcon}>
        <IconButton
          icon={{ Component: Directions, color: COLOR_INTERACTIVE_PRIMARY }}
          onClick={handleDirectionsClick}
          title={StringConstantsMixin.strings.DIRECTIONS}
          testId="map-header-directions"
          variant="elevated"
        />
      </div>
      <div className={styles.circleIcon}>
        <IconButton
          icon={{ Component: Share, color: COLOR_INTERACTIVE_PRIMARY }}
          onClick={handleShareClick}
          title={StringConstantsMixin.strings.SHARE}
          testId="map-header-share"
          variant="elevated"
        />
      </div>
      <MenuPop variant="circle" items={menuItems} />
    </div>
  );
};

export default HeaderButtons;

HeaderButtons.propTypes = {
  context: object.isRequired,
  user: object.isRequired,
  handleDirectionsClick: func.isRequired,
  handleShareClick: func.isRequired,
  menuItems: array.isRequired
};
